'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import MultiCarousel from './MultiCarouselAlsoLike';
import classes from './RelatedItems.module.css';
import algoliasearch from 'algoliasearch';

const client = algoliasearch('Y9W13WMLAZ', '4176cc4a0843962d60e0379983534d75');

const MoreFromThisBrand = (props) => {
	const { listing, deviceWidth } = props;

	const [sameBrand, setSameBrand] = useState([]);

	const getListingsHandler = async (brand) => {
		const index = await client.initIndex(
			process.env.NEXT_PUBLIC_OG_DB === 'false'
				? 'kashew_listings'
				: `kashew_listings_branded_deals`
		);
		await index
			.search(brand, {
				clickAnalytics: true,
				hitsPerPage: 15,
				page: 0,
			})
			.then(async (res) => {
				setSameBrand(res.hits.filter((item) => item._id !== listing._id));
			})
			.catch((err) => {
				console.log(err);
			});
	};

	useEffect(() => {
		if (listing.brand) {
			getListingsHandler(listing.brand);
		}
	}, [listing]);

	return (
		<>
			{sameBrand && sameBrand.length > 0 && (
				<div className={classes.similarItems}>
					<div className={classes.headerBox}>
						<h6 className={classes.header}>More from {listing.brand}</h6>
						<Link
							className={classes.Link}
							href={`/brand/${listing.brand
								.replace(/ /g, '-')
								.replace(/&/g, 'and')
								.toLowerCase()}`}
						>
							<h6 className={classes.seeAll}>See all</h6>
						</Link>
					</div>
					<MultiCarousel listings={sameBrand} deviceWidth={deviceWidth} />
				</div>
			)}
		</>
	);
};
export default MoreFromThisBrand;
